import { render, staticRenderFns } from "./CaKui.vue?vue&type=template&id=1fe5f987&scoped=true&"
import script from "./CaKui.vue?vue&type=script&lang=js&"
export * from "./CaKui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe5f987",
  null
  
)

export default component.exports